import i18n, { I18N_NS } from "Config/i18n";

export function formatUsername(contactObject: { firstName?: string; surname?: string }) {
  if (!contactObject) {
    return i18n.t("[Unknown user]", { ns: I18N_NS.GENERAL });
  }
  if (contactObject.firstName && contactObject.surname) {
    return `${contactObject.surname}, ${contactObject.firstName}`;
  } else {
    return contactObject?.surname || contactObject?.firstName || "";
  }
}
